import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	pageData: {
		id: "",
		code: "",
		name: "",
		startDate: "",
		shortStartDate: "",
		endDate: "",
		shortEndDate: "",
		duration: 0,
		durationString: "",
		modality: {
			id: "",
			Code: "",
			name: "",
		},
		trainingSessions: [],
	},
};

const ActionDetailsSlice = createSlice({
	name: "ActionDetails",
	initialState: initialState,
	reducers: {
		updatePageData(state, action) {
			// console.log("update ActionDetails");
			// console.log(action);

			state.pageData = action.payload;
		},
	},
});

export const ActionDetailsActions = ActionDetailsSlice.actions;

export default ActionDetailsSlice;
